import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { NgxSplideModule } from 'ngx-splide';
import { RouterModule } from '@angular/router';
import { JoyrideModule } from 'ngx-joyride';
import { LandingComponent } from './landing.component';
import { LANDING_ROUTE } from './landing.route';

@NgModule({
  imports: [SharedModule, NgxSplideModule, RouterModule.forChild([LANDING_ROUTE]), JoyrideModule.forChild()],
  declarations: [LandingComponent],
  exports: [
    LandingComponent
  ]
})
export class LandingModule{
}
